import {
  CONVERSION_CHECK_VALIDITY_PREFIX,
  PURCHASE_POINTS_UNIT,
  formatAmountInEuros,
} from "@/features/purchasePoints/config/purchasePoints.config";
import type { PurchasePointsConversion } from "@/features/purchasePoints/types/purchasePointsConversion.type";

type ConversionHistoryRowProps = { conversion: PurchasePointsConversion };

const SECONDARY_LINE = "text-sm text-gray-500 dark:text-gray-400";
const AMOUNT = "ml-auto whitespace-nowrap font-semibold text-gray-900 dark:text-white";

const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("fr-FR");
};

export const ConversionHistoryRow = ({ conversion }: ConversionHistoryRowProps) => (
  <li
    className="flex items-center gap-3 border-b border-gray-200 py-3 last:border-b-0 dark:border-gray-700"
    data-testid="conversion-history-row"
  >
    <div className="flex min-w-0 flex-col">
      <span className="truncate font-medium text-gray-900 dark:text-white">
        {`${conversion.points.toLocaleString("fr-FR")} ${PURCHASE_POINTS_UNIT}`}
      </span>
      <span className={SECONDARY_LINE} data-testid="conversion-history-date">
        {formatDate(conversion.converted_at)}
      </span>
      {/* The server answers with the last usable day: the browser clock never
          decides whether a check is still good. */}
      <span className={SECONDARY_LINE} data-testid="conversion-history-validity">
        {`${CONVERSION_CHECK_VALIDITY_PREFIX} ${formatDate(conversion.check.expires_on)}`}
      </span>
    </div>

    <span className={AMOUNT} data-testid="conversion-history-amount">
      {formatAmountInEuros(conversion.amount_cents)}
    </span>
  </li>
);

ConversionHistoryRow.displayName = "ConversionHistoryRow";
